/**
 * executive_black.js — Monarch (Annual Corporate Report)
 * ─────────────────────────────────────────────────────────────────────────────
 * Design Bible:
 *   Brand Name:   Monarch
 *   Purpose:      Boardroom Presence & Executive Leadership
 *   Reads Like:   S&P 500 Corporate Annual Report / Executive Statement
 *   Emotion:      Commanding, Elite, Authoritative
 *   Personality:  Powerful
 *   Reading Speed: Medium, reading-first
 *   Scanning:     Top Banner ↓
 *   Hero Moment:  Full-bleed corporate black header banner (#0F0F0F) with gold accent
 *                 rules and a C-suite narrative block.
 *   ATS Target:   High ATS Compatibility
 *
 * Forbidden Elements:
 *   ✗ Sidebars or columns (executives do not split their story)
 *   ✗ Technical tags, badges, CGPA cards, or timeline dots
 *   ✗ Monospace text
 */

export const executive_black = {
  id: 'executive-black',
  version: 3,
  renderer: 'enterprise',
  name: 'Monarch',
  layout: 'single-column',
  theme: 'classic-navy',
  density: 'luxury',
  sectionDividerStyle: 'full-bar',
  // Narrative Shift: Achievements (P&L, growth, scaling metrics) leads immediately before Experience
  sectionOrder: ['personal-info', 'summary', 'achievements', 'experience', 'education', 'skills', 'certifications'],
  components: {
    header: 'header-executive',
    experience: 'experience-executive',
    projects: 'projects-feature-block',
    skills: 'skills-categorized',
    education: 'education-classic',
  },
  layouts: {
    'single-column': {
      component: 'single-column',
      slots: {
        header: ['personal-info'],
        main: ['summary', 'achievements', 'experience', 'education', 'skills', 'certifications'],
      },
      overrides: {
        '--font-family-primary': '"Playfair Display", Georgia, serif',
        '--font-family-secondary': '"Inter", "Helvetica Neue", Arial, sans-serif',
        '--color-primary': '#0F0F0F', // Boardroom Black
        '--color-secondary': '#1A1A1A',
        '--color-accent': '#C9A84C', // Executive Warm Gold
        '--color-text-main': '#1F2022',
        '--color-text-light': '#5C5E62',
        '--color-border': '#E8E0D0',
        '--color-bg-page': '#FFFDF9', // Warm premium paper white
        '--spacing-margin': '32px',
        '--spacing-section-mb': '20px',
        '--spacing-item-mb': '16px',
        '--spacing-bullet-gap': '5px',
      },
    },
  },
  styleOverrides: {
    '--font-size-display': '28pt',
    '--weight-display': '800',
    '--heading-weight': '700',
    '--heading-text-transform': 'uppercase',
    '--heading-letter-spacing': '0.12em',
    '--border-thickness-heading': '0',
    '--bullet-style': 'square',
    '--font-size-heading': '9pt',
    '--font-size-body': '9.5pt',
    '--font-size-bullet': '9.2pt',
    '--line-height-body': '1.65',
  },
};

export default executive_black;
